import { Typography } from 'antd'
import styled from 'styled-components'

const StyledDietDescriptorSpacing = styled(Typography.Text)`
  margin: 0 0.5rem;
`

export default StyledDietDescriptorSpacing
